// @flow
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import Input from '../../../../components/Input'
import Button from '../../../../components/Button'
import Textarea from '../../../../components/Textarea'

type Props = {
  property: Object,
  onSubmit: Function,
  submitting: boolean,
  handleSubmit: Function
}

class OfferForm extends Component {
  props: Props

  handleSubmit = (data) =>
    this.props.onSubmit({
      offer: {
        mls_id: this.props.property.mlsId,
        listing_id: this.props.property.listingId,
        ...data
      }
    })

  render() {
    const { handleSubmit, submitting } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Field
          name="amount"
          type="number"
          label="Offer amount"
          component={Input}
          style={{ marginBottom: '1rem' }}
        />
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div style={{ marginBottom: '1rem', marginRight: '2rem' }}>
            <label htmlFor="payment">Payment method</label>
            <div>
              <label htmlFor="payment" style={{ marginRight: '.5rem' }}>
                <Field
                  name="payment"
                  component="input"
                  type="radio"
                  value="cash"
                />
                &nbsp;Cash
              </label>
              <label htmlFor="payment">
                <Field
                  name="payment"
                  component="input"
                  type="radio"
                  value="mortgage"
                />
                &nbsp;Mortgage
              </label>
            </div>
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label htmlFor="other_agent">
              Are you currently working with another agent?
            </label>
            <div>
              <label htmlFor="other_agent" style={{ marginRight: '.5rem' }}>
                <Field
                  name="other_agent"
                  component="input"
                  type="radio"
                  value="true"
                />
                &nbsp;Yes
              </label>
              <label htmlFor="other_agent">
                <Field
                  name="other_agent"
                  component="input"
                  type="radio"
                  value="false"
                />
                &nbsp;No
              </label>
            </div>
          </div>
        </div>
        <Field
          rows={6}
          name="notes"
          component={Textarea}
          label="Notes (optional)"
          style={{ marginBottom: '1rem' }}
        />
        <Button color="primary" disabled={submitting} animating={submitting}>
          Submit
        </Button>
      </form>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (!values.amount) {
    errors.amount = 'Please enter amount'
  }
  return errors
}

export default reduxForm({
  form: 'offer',
  validate
})(OfferForm)



// WEBPACK FOOTER //
// ./src/views/NewOffer/components/OfferForm/index.js